import styled from 'styled-components';


const ShopContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

const ShopHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  h1 {
    font-size: clamp(2rem, 4vw, 2.5rem);
    color: var(--primary);
    margin-bottom: 1rem;
  }

  p {
    color: var(--gray);
    font-size: 1.1rem;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
`;

const WarningDialog = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  padding: 2.5rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  max-width: 500px;
  width: 90%;
  z-index: 1000;
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transition: opacity var(--transition-speed) ease, visibility var(--transition-speed) ease;

  h2 {
    color: var(--primary);
    font-size: 1.5rem;
    margin-bottom: 1rem;
    text-align: center;
  }

  p {
    color: var(--gray-dark);
    text-align: center;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    opacity: 0.9;
    font-size: 1.1rem;
  }
`;

const Overlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transition: opacity var(--transition-speed) ease, visibility var(--transition-speed) ease;
  z-index: 999;
  backdrop-filter: blur(2px);
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;

  button {
    flex: 1;
    max-width: 150px;
  }
`;

const Button = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  padding: 0.75rem 1.5rem;
  border-radius: var(--radius-full);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-speed) var(--transition-bounce);
  border: 2px solid var(--primary);
  
  ${props => props.$variant === 'primary' ? `
    background: var(--primary);
    color: var(--white);
    
    &:hover {
      background: var(--primary-dark);
      border-color: var(--primary-dark);
      transform: var(--hover-lift-sm);
    }
  ` : `
    background: transparent;
    color: var(--primary);
    
    &:hover {
      background: var(--primary-light);
      transform: var(--hover-lift-sm);
    }
  `}
`;

const ShopContent = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  border-radius: var(--radius-lg);
  margin: 0 auto;
  max-width: 800px;
`;

const ShopButton = styled.button`
  padding: 1.25rem 2.5rem;
  font-size: 1.2rem;
  background: var(--primary);
  color: var(--white);
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  font-weight: 600;
  transition: all var(--transition-speed) var(--transition-bounce);
  box-shadow: var(--shadow-md);

  &:hover {
    transform: var(--hover-lift-sm);
    background: var(--primary-dark);
    box-shadow: var(--shadow-lg);
  }
`;

export { ShopContainer, ShopHeader, WarningDialog, Overlay, ButtonGroup, Button, ShopContent, ShopButton };